export const removeDuplication = (list: string[]) => {
  return [...new Set(list)];
};
